import { openModal } from "../../alpine/utils/dispatcher";

export function handleResponseError(event) {
  const xhr = event.detail?.xhr;

  if (!xhr) return;

  const status = xhr.status;

  if (![400, 403, 404, 405, 429, 500].includes(status)) {
    return;
  }

  const box = document.getElementById("hx-errors");

  if (!box) return;

  box.innerHTML = xhr.responseText;

  openModal("hx-errors");
}
